import { AtsMessageTemplateVisibilityEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export const messageTemplateVisibilityLabel = (visibility: AtsMessageTemplateVisibilityEnum) => {
  switch (visibility) {
    case 'company':
      return i18n.t('ats.manage_message_templates.visibility.company')

    case 'personal':
      return i18n.t('ats.manage_message_templates.visibility.personal')

    default:
      throw new Error(`Ats message template visibility: ${visibility} not valid`)
  }
}

export const isPersonal = (visibility: AtsMessageTemplateVisibilityEnum) =>
  visibility === 'personal'
